import React from "react"

class GrantsHeader extends React.Component {
	render() {
		return (
			<div className="grants-header-container">
				{this.props.row.title}
				<div className="grant-actions">
					<button onClick={this._handleNewGrant.bind(this)} title="Ajouter une subvention"><i className="fa fa-plus" /></button>
				</div>
			</div>
		)
	}

	_handleNewGrant() {
		this.props.onCustomAction("new_grant", {project: this.props.row.project, theme: this.props.row.theme, subtheme: this.props.row.subtheme, awarded: this.props.row.type == "awarded"})
	}

}

export default GrantsHeader



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/grants-header.js